/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Auto_PostInputs */

const en_story_auto_post = /** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-post a 24h story when published`)
};

const es_story_auto_post = /** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar automáticamente una historia de 24h al publicar`)
};

const fr_story_auto_post = /** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier automatiquement une story 24h lors de la publication`)
};

const de_story_auto_post = /** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story automatisch 24h nach Veröffentlichung posten`)
};

const id_story_auto_post = /** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengeposan cerita 24 jam otomatis saat diterbitkan`)
};

/** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */
const ja_story_auto_post = en_story_auto_post;

/** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */
const zh_story_auto_post = en_story_auto_post;

/** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */
const ar_story_auto_post = en_story_auto_post;

/** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */
const it_story_auto_post = en_story_auto_post;

/** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */
const ru_story_auto_post = en_story_auto_post;

/** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */
const pt_story_auto_post = en_story_auto_post;

/** @type {(inputs: Story_Auto_PostInputs) => LocalizedString} */
const ko_story_auto_post = en_story_auto_post;

/**
* | output |
* | --- |
* | "Auto-post a 24h story when published" |
*
* @param {Story_Auto_PostInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_auto_post = /** @type {((inputs?: Story_Auto_PostInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Auto_PostInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_auto_post(inputs)
	if (locale === "es") return es_story_auto_post(inputs)
	if (locale === "fr") return fr_story_auto_post(inputs)
	if (locale === "de") return de_story_auto_post(inputs)
	if (locale === "ja") return ja_story_auto_post(inputs)
	if (locale === "zh") return zh_story_auto_post(inputs)
	if (locale === "ar") return ar_story_auto_post(inputs)
	if (locale === "id") return id_story_auto_post(inputs)
	if (locale === "it") return it_story_auto_post(inputs)
	if (locale === "ru") return ru_story_auto_post(inputs)
	if (locale === "pt") return pt_story_auto_post(inputs)
	return ko_story_auto_post(inputs)
});